import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Chip when the customer has an active service agreement.
 * Contract: report.active_service_agreement
 *   { present, id, name, agreement_number, status, expires_at }
 *   or { present: false }
 */
export default function ReportActiveAgreementChip({ report }) {
  const { t } = useTranslation();
  const signal = report?.active_service_agreement;

  if (!signal || signal.present === false || !signal.id) return null;

  const label = signal.agreement_number || signal.name || signal.id;

  return (
    <Link
      to={`/dashboard/service/agreements/${signal.id}`}
      className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800 hover:bg-emerald-100"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden="true" />
      {t("report.active_agreement.chip", { number: label })}
    </Link>
  );
}
